import { UnaryOperator } from "@archipad-js/core/query";

import { BuiltInOperator, CustomOperator } from "./config.types";

export class ConfigOperator {
    constructor(public readonly name: string, public readonly fn: UnaryOperator<BuiltInOperator | CustomOperator>) {}
}
